<template>
  <div class="Splash_container" :class="{ 'fade-out': pageLoaded }">
    <!-- <svg-icon icon="banner-logo-icon" :size="150"></svg-icon> -->
    <img src="@/assets/images/logo_test.png" alt="Logo" class="splash-logo" @load="onLogoLoad" />
    <video
      v-show="videoSrc"
      :src="videoSrc"
      autoplay
      preload="auto"
      playsinline
      class="video-player"
      @ended="onVideoEnded"
      @canplaythrough="handleCanplaythrough"
    ></video>
  </div>
</template>
<script setup>
import { ref } from 'vue';

const pageLoaded = ref(false);

const emit = defineEmits(['hiddenSplash']);

const videoSrc = ref('');
const showVideo = ref(false);

function handleCanplaythrough() {
  showVideo.value = true;
}

function onLogoLoad() {
  // Start the 4-second fade-in animation
  setTimeout(() => {
    onAnimationComplete();
  }, 4000);
}

function onAnimationComplete() {
  pageLoaded.value = true;
  setTimeout(() => {
    emit('hiddenSplash');
  }, 600);
}

function onVideoEnded() {
  emit('hiddenSplash');
}
</script>

<style lang="less" scoped>
.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Splash_container {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: absolute;
  background: #000;
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 99;
  transition: opacity 0.5s ease-in-out;
  &.fade-out {
    opacity: 0;
    pointer-events: none;
  }

  .splash-logo {
    width: 200px;
    height: 200px;
    // width: auto;
    // height: auto;
    opacity: 0;
    animation: fadeIn 4s ease-in-out forwards;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
